"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Interface = require("./interface");
exports.Interface = Interface;
var base_1 = require("./base");
exports.Guide = base_1.default;
var label_1 = require("./label");
exports.Label = label_1.default;
var Tooltip = require("./tooltip");
exports.Tooltip = Tooltip;
var Axis = require("./axis");
exports.Axis = Axis;
var Legend = require("./legend");
exports.Legend = Legend;
var Annotation = require("./annotation");
exports.Annotation = Annotation;
exports.default = base_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/index.js
// module id = 271
// module chunks = 37